module.exports = __webpack_public_path__ + "static/media/PhilgFlixLogo-150px.95a5b836.png";